import {COLLECTION_NAME} from "./actions";
import createVersionedCollectionReducer from 'store/generic/reducer';

export default createVersionedCollectionReducer(COLLECTION_NAME);


// WEBPACK FOOTER //
// ./src/store/packages/reducer.js